(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/api-utils.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/api-utils.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

(function () {
  'use strict';

  var ContentUrlBuilder = function () {
    function ContentUrlBuilder(path, routesDomain) {
      _classCallCheck(this, ContentUrlBuilder);
      var contentApiVersion = svs.core.config.data.svsconfig.contentApiVersion || 1;
      this.path = path;
      this.routesDomain = routesDomain;
      if (!this.path) {
        throw new Error('no path-parameter specified to constructor');
      }
      this.path = path.indexOf('/') === 0 ? path : "/".concat(path);
      if (this.path.indexOf('/content') !== 0) {
        this.path = "/content/".concat(contentApiVersion).concat(this.path);
      }
      this.params = '';
      this.addParams({
        routesDomain: routesDomain || svs.core.config.data.svsconfig.routesDomain
      });
    }

    _createClass(ContentUrlBuilder, [{
      key: "addParams",
      value: function addParams(newParams) {
        var newParamsString = Object.keys(newParams).filter(function (field) {
          return newParams[field] !== null && newParams[field] !== undefined;
        }).map(function (field) {
          return [field, newParams[field]].join('=');
        }).join('&');
        if (newParamsString) {
          this.params += (this.params ? '&' : '?') + newParamsString;
        }
        return this;
      }

    }, {
      key: "build",
      value: function build() {
        return this.path + this.params;
      }
    }]);
    return ContentUrlBuilder;
  }();
  var validateOptions = function validateOptions(options, requiredProperties) {
    if (!options) {
      return 'options required';
    }
    requiredProperties = requiredProperties || [];
    for (var i = 0; i < requiredProperties.length; i++) {
      if (!options[requiredProperties[i]]) {
        return "".concat(requiredProperties[i], " required");
      }
    }
    return null;
  };

  function appendUserParams(params) {
    params.userSegment = svs.core.userSession.getSegmentId() || 0;
  }

  function callJupiter(path, callback) {
    var useCallback = callback && typeof callback === 'function';
    return svs.core.jupiter.call({
      context: this,
      data: {},
      method: 'GET',
      path: path
    }, useCallback ? function (data) {
      callback(null, data);
    } : undefined, useCallback ? function (err) {
      callback(err);
    } : undefined);
  }
  svs.content.shared.ContentUrlBuilder = ContentUrlBuilder;
  svs.content.shared.appendUserParams = appendUserParams;
  svs.content.shared.validateOptions = validateOptions;
  svs.content.shared.callJupiter = callJupiter;
})();

 })(window);